// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.misPage {
  min-height: calc(100vh - 72px);
  padding: 14px;
  background:
    radial-gradient(circle at top left, rgba(147, 197, 253, 0.08), transparent 26%),
    radial-gradient(circle at bottom right, rgba(212, 175, 55, 0.08), transparent 24%),
    #020304;
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/MarketIntelligencePage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb;;;WAGS;AACX","sourcesContent":[".misPage {\n  min-height: calc(100vh - 72px);\n  padding: 14px;\n  background:\n    radial-gradient(circle at top left, rgba(147, 197, 253, 0.08), transparent 26%),\n    radial-gradient(circle at bottom right, rgba(212, 175, 55, 0.08), transparent 24%),\n    #020304;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
